<template>
  <form>
    <div class="mb-3" v-for="input in form" :key="input.id">
      <component
        :is="input.component"
        v-bind="input.props"
        @onChangeElement="handleChangeComponent"
      ></component>
    </div>
  </form>
</template>
<script>
import InputDynamicBuilder from '@/components/planning/PlanningInputBuilder';
export default {
  props: {
    questions: {
      type: Array,
      default: () => [],
    },
    answers: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      values: new Map(),
    };
  },
  computed: {
    form() {
      const form = this.questions.map((question, index) =>
        this.dynamicInput(question, this.answerByQuestionId(question.id), index + 1),
      );
      return form;
    },
  },
  methods: {
    dynamicInput(question, answer, index) {
      const input = new InputDynamicBuilder(question, answer, index);
      return input.getDynamicComponent();
    },
    handleChangeComponent({ question, answer, additional_data }) {
      const existQuestion = this.values.has(question);
      if (existQuestion) this.values.delete(question);
      this.values.set(question, { answer, additional_data });
    },
    answerByQuestionId(questionId) {
      if (!this.answers) return [];
      const answer = this.answers.find((answer) => answer.id === questionId)?.parent_reponses;
      return answer;
    },
  },
};
</script>
